module.exports = __webpack_public_path__ + "img/yc-step-2-img@2x.png";